import { useCurrentStateAndParams } from "@uirouter/react";

import { SIWorldwideOverview } from "app/pages/website-performance/sales-intelligence/SIWorldwideOverview";
import { SIWorldwideOverviewCompare } from "app/pages/website-performance/sales-intelligence/SIWorldwideOverviewCompare";

export const WebsitePerformanceRoot = () => {
    const { params } = useCurrentStateAndParams();
    const key = typeof params.key === "string" ? params.key : "";
    const isCompare = key.split(",").length > 1;

    if (isCompare) {
        return <SIWorldwideOverviewCompare hideFooter />;
    } else {
        return <SIWorldwideOverview />;
    }
};
